import * as React from "react";
import { useSelector } from "react-redux";
import { getAllProducts } from "./util";
import ProductList from "../ProductList";
import { DataContext } from "../common/dataProvider";
import { STATE_CULTURE } from "../../common/state";
import slugify from "../../components/common/slugify";

// Returns and displays products or events based on selected link, such as choosing "Produkter" or "Simbassäng" in the headline links.
// In essence, filters what is to be displayed based on groups, if it's a product or event.
const AllProducts = ({ originalPage, page, setPosition }) => {
  const { data } = React.useContext(DataContext);
  const { culture, config } = useSelector((state) => ({
    culture: state.cookies[STATE_CULTURE],
    config: state.config,
  }));

  const groups = page.productGroups;
  const products = getAllProducts(groups, config, data, culture);
  const publicBookings =
    page.publicBookings?.map((publicBooking) => {
      const publicBookingConfig =
        config.publicBookingConfigurator?.find(
          (pb) => pb.name === publicBooking
        ) || {};
      const slug = `/publicbooking/${slugify(publicBookingConfig.name)}`;

      return {
        ...publicBookingConfig,
        slug,
      };
    }) || [];

  const listType =
    window.innerWidth < 667 ? page.listType?.sm : page.listType?.lg;

  return (
    <div>
      <ProductList
        originalPage={originalPage}
        products={products}
        events={page.events}
        listType={listType}
        publicBookings={publicBookings}
        setPosition={setPosition}
        data={data}
      />
    </div>
  );
};

export default AllProducts;
